import moment from 'moment';

export const ProgramResourceType = {
	EnrollmentLink: 0,
	MoreInformation: 1
}

export const ResourceType = {
	Pdf: 0,
	ExternalLink: 1,
}

export const NoteType = {
	Practice: 0,
	Personal: 1,
}

export const FundingStatus = {
	Unknown: 0,
	NotAvailable: 1,
	Available: 2,
	ReenrollmentOnly: 3,
};

export const Insurance = [
	{ Id: 1, Label: 'Commercial', Property: 'commercial' },
	{ Id: 2, Label: 'Medicare', Property: 'medicare' },
	{ Id: 3, Label: 'Medicaid', Property: 'medicaid' },
	{ Id: 7, Label: 'VA / DOD', Property: 'vaDoD' },
	{ Id: 5, Label: 'Uninsured', Property: 'uninsured' }
];

export const AssistanceProgram_ProgramTypesEnum = {
	Manufacturer: 0,
	Foundation: 1
};

export const DefaultsBenefitPeriodType = {
	Enrollment: 1,
	Calendar365: 2
};

export const AssistanceProgram_ConnectivityTypesEnum = {
	Manual: 0,
	OutboundDigitalApplication: 1,
	DigitalEnrollment: 2,
	DigitalEnrollment15: 3,
	AssistedEnrollment: 4
};

export const AssistanceProgram_ConnectivityTypes = [
	{
		Id: AssistanceProgram_ConnectivityTypesEnum.Manual,
		Type: 'Manual Application',
		Description: `This program does not currently support any electronic transmissions of data with AssistPoint. Use the Quick Links in Step 3 to manually process your application.`
	},
	{
		Id: AssistanceProgram_ConnectivityTypesEnum.OutboundDigitalApplication,
		Type: 'Outbound Digital Application',
		Description: `While this program doesn't provide a full interface, we can transmit applications to the program for you.`
	},
	{
		Id: AssistanceProgram_ConnectivityTypesEnum.DigitalEnrollment,
		Type: 'Digital Enrollment',
		Description: `This program supports end to end automation to fully engage with their financial assistance services directly from within AssistPoint (digital send and receive process to apply, enroll, monitor and measure).`
	},
	{
		Id: AssistanceProgram_ConnectivityTypesEnum.DigitalEnrollment15,
		Type: 'Digital Enrollment',
		Description: `This program supports end to end automation to fully engage with their financial assistance services directly from within AssistPoint (digital send and receive process to apply, enroll, monitor and measure).`
	},
	{
		Id: AssistanceProgram_ConnectivityTypesEnum.AssistedEnrollment,
		Type: 'Assisted Enrollment',
		Description: `This program expedites the completion of the enrollment application for a patient by pre-populating known fields/information, saving you time and duplicate entry when applying for assistance.`
	}
];

export const ApplicationServiceStatus = {
	Selected: 0,
	Pending: 1,
	Approved: 2,
	Denied: 3,
	Discarded: 4,
	Complete: 5,
	Archived: 6,
	Error: 7
}

export const EnrollmentStatus = {
	Active: 1,
	Expired: 2,
	Exhausted: 3,
	Closed: 4,
}

export const ServiceCategoryType = {
	CoPay: 1,
	FreeDrug: 2,
	ReplacementDrug: 3,
	Other_PharmacyTriage: 6,
	Other_Grocery_Food: 8,
	Other_Household_Bill: 9,
	Other_Insurance_Premiums: 10,
	Other_Practice_Balances: 11,
	Other_Misc: 12,
	Other_Physical_Therapy: 13,
	Other_Travel: 14,
	Other_Wigs: 15,
	Other_Limited_Supply: 16,
	Other_Diagnostic_Testing: 17,
	Other_Education: 18,
	Admin_Reimb_Support: 20,
	Admin_Referral_To: 21
}

export const Route = {
	NotDefined: 0,
	Buccal: 1,
	Dental: 2,
	Epidural: 3,
	Hemodialysis: 4,
	Implantation: 5,
	Inhalation: 6,
	Injection: 7,
	Intraarticular: 8,
	Intracavernosal: 9,
	Intradermal: 10,
	Intramuscular: 11,
	Intraocular: 12,
	Intraperitoneal: 13,
	Intrapleural: 14,
	Intrathecal: 15,
	Intrauterine: 16,
	Intravenous: 17,
	Intravesical: 18,
	Irrigation: 19,
	Miscellaneous: 20,
	MucousMembrane: 21,
	Nasal: 22,
	Ophthalmic: 23,
	Oral: 24,
	Otic: 25,
	Perfusion: 26,
	Rectal: 27,
	Subcutaneous: 28,
	Sublingual: 29,
	Topical: 30,
	Transdermal: 31,
	Translingual: 32,
	Urethral: 33,
	Vaginal: 34,
	Intraarterial: 35,
	Intralesional: 36,
	Intravascular: 37
}

export const States = [
	{ key: 1, value: 'AL', text: 'Alabama' },
	{ key: 2, value: 'AK', text: 'Alaska' },
	{ key: 3, value: 'AZ', text: 'Arizona' },
	{ key: 4, value: 'AR', text: 'Arkansas' },
	{ key: 5, value: 'CA', text: 'California' },
	{ key: 6, value: 'CO', text: 'Colorado' },
	{ key: 7, value: 'CT', text: 'Connecticut' },
	{ key: 8, value: 'DE', text: 'Delaware' },
	{ key: 9, value: 'DC', text: 'District Of Columbia' },
	{ key: 10, value: 'FL', text: 'Florida' },
	{ key: 11, value: 'GA', text: 'Georgia' },
	{ key: 12, value: 'HI', text: 'Hawaii' },
	{ key: 13, value: 'ID', text: 'Idaho' },
	{ key: 14, value: 'IL', text: 'Illinois' },
	{ key: 15, value: 'IN', text: 'Indiana' },
	{ key: 16, value: 'IA', text: 'Iowa' },
	{ key: 17, value: 'KS', text: 'Kansas' },
	{ key: 18, value: 'KY', text: 'Kentucky' },
	{ key: 19, value: 'LA', text: 'Louisiana' },
	{ key: 20, value: 'ME', text: 'Maine' },
	{ key: 21, value: 'MD', text: 'Maryland' },
	{ key: 22, value: 'MA', text: 'Massachusetts' },
	{ key: 23, value: 'MI', text: 'Michigan' },
	{ key: 24, value: 'MN', text: 'Minnesota' },
	{ key: 25, value: 'MS', text: 'Mississippi' },
	{ key: 26, value: 'MO', text: 'Missouri' },
	{ key: 27, value: 'MT', text: 'Montana' },
	{ key: 28, value: 'NE', text: 'Nebraska' },
	{ key: 29, value: 'NV', text: 'Nevada' },
	{ key: 30, value: 'NH', text: 'New Hampshire' },
	{ key: 31, value: 'NJ', text: 'New Jersey' },
	{ key: 32, value: 'NM', text: 'New Mexico' },
	{ key: 33, value: 'NY', text: 'New York' },
	{ key: 34, value: 'NC', text: 'North Carolina' },
	{ key: 35, value: 'ND', text: 'North Dakota' },
	{ key: 36, value: 'OH', text: 'Ohio' },
	{ key: 37, value: 'OK', text: 'Oklahoma' },
	{ key: 38, value: 'OR', text: 'Oregon' },
	{ key: 39, value: 'PA', text: 'Pennsylvania' },
	{ key: 40, value: 'RI', text: 'Rhode Island' },
	{ key: 41, value: 'SC', text: 'South Carolina' },
	{ key: 42, value: 'SD', text: 'South Dakota' },
	{ key: 43, value: 'TN', text: 'Tennessee' },
	{ key: 44, value: 'TX', text: 'Texas' },
	{ key: 45, value: 'UT', text: 'Utah' },
	{ key: 46, value: 'VT', text: 'Vermont' },
	{ key: 47, value: 'VA', text: 'Virginia' },
	{ key: 48, value: 'WA', text: 'Washington' },
	{ key: 49, value: 'WV', text: 'West Virginia' },
	{ key: 50, value: 'WI', text: 'Wisconsin' },
	{ key: 51, value: 'WY', text: 'Wyoming' }
];

export const ShortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const EnrollmentStatusValues = [
	{ key: 1, value: 'Active' },
	{ key: 2, value: 'Expired' },
	{ key: 3, value: 'Exhausted' },
	{ key: 4, value: 'Not Needed' },
]

export const AssistanceTypeEnum = {
	CoPay: 0,
	FreeDrug: 1,
	Admin: 2,
	Other: 3,
	AllServices: 4,
	Archived: 5
}

export const InteractionType = {
	PhoneCall: 0,
	AccountReview: 1,
	Appointment: 2,
	Other: 3,
	FollowUp: 4,
	StatusChange: 5,
	Creation: 6,
	Approval: 7,
	Denial: 8,
	Discard: 9,
	AwardUpdated: 10,
	AddCharge: 11,
	AddPayment: 12,
	Consultation: 13,
	PatientAssistance: 14,
	GeneralNote: 15,
	AppStatusNote: 16,
}

export const PatientJourneyInteractionDataBitMapping = {
	DiscussedBalanceFinancialResponsibility: {
		dataName: 'Discussed Balance/Financial Responsibility',
		dataValue: '5'
	},
	DiscussedInsuranceMedicareBenefits: {
		dataName: 'Discussed Insurance/Medicare Benefits',
		dataValue: '6'
	},
	MedicareOcm: {
		dataName: 'Medicare OCM',
		dataValue: '7'
	},
	CompletedMedicareEnrollmentPhone: {
		dataName: 'Completed Medicare Open Enrollment Letter - Phone',
		dataValue: '8'
	},
	CompletedMedicateEnrollmentInPerson: {
		dataName: 'Completed Medicare Open Enrollment Letter - In Person',
		dataValue: '9'
	},
	Enrolled: {
		dataName: 'Enrolled',
		dataValue: '10'
	},
	NotEnrolledPatientChoice: {
		dataName: 'Not Enrolled - Patient Choice',
		dataValue: '11'
	},
	NotEnrolledFundingNotAvailable: {
		dataName: 'Not Enrolled - Funding Not Available',
		dataValue: '12'
	},
	NotEnrolledCriteriaNotMet: {
		dataName: 'Not Enrolled - Criteria Not Met',
		dataValue: '13'
	},
	NA: {
		dataName: 'N/A',
		dataValue: '14'
	},
	EnrolledSupplementalInsurance: {
		dataName: 'Enrolled in Supplemental Insurance',
		dataValue: '15'
	},
	Other: {
		dataName: 'Other',
		dataValue: '16'
	},
	NotEnrolledPatientNotRequireAssistance: {
		dataName: 'Not Enrolled - Patient Does Not Require Assistance',
		dataValue: '17'
	}
}

export const ServiceViewEnum = {
	EditAward: 1,
	Documents: 2,
	ViewApplication: 3,
	Interactions: 4,
	Detail: 5,
}

export const getMonthsAsDays = (months) => moment.duration(months, 'months').asDays();

export const BackDateTimelyFilingTimePeriods = [
	{ text: '0 Days', value: '0' },
	{ text: '1 Day', value: '1' },
	{ text: '30 Days', value: '30' },
	{ text: '45 Days', value: '45' },
	{ text: '60 Days', value: '60' },
	{ text: '90 Days', value: '90' },
	{ text: '120 Days', value: '120' },
	{ text: '150 Days', value: '150' },
	{ text: '180 Days', value: '180' },
	{ text: '6 Months', value: getMonthsAsDays(6).toString() },
	{ text: '7 Months', value: getMonthsAsDays(7).toString() },
	{ text: '8 Months', value: getMonthsAsDays(8).toString() },
	{ text: '9 Months', value: getMonthsAsDays(9).toString() },
	{ text: '10 Months', value: getMonthsAsDays(10).toString() },
	{ text: '11 Months', value: getMonthsAsDays(11).toString() },
	{ text: '12 Months', value: getMonthsAsDays(12).toString() },
	{ text: '1 Year', value: '365' },
]

export const ApplicationStatusEnum = {
	Draft: 0,
	AuthRequiredBoth: 1,
	AuthRequiredPhysician: 2,
	AuthRequiredPatient: 3,
	AuthRequestedBoth: 4,
	AuthRequestedPhysician: 5,
	AuthRequestedPatient: 6,
	ReviewReady: 7,
	ReviewFailed: 8,
	SubmittedSending: 9,
	SubmittedOpen: 10,
	SubmittedClosed: 11,
	Abandoned: 12
};

export const VerificationSources = [
	'Phone', 'Fax', 'Payer Portal', 'Other'
];

export const PaymentSourceEnum = {
	CentricityPaymentsAndCharges: 1,
	GenenTechPaymentsAndCharges: 2,
	CoherusPaymentsAndCharges: 3,
	SanofiPaymentsAndCharges: 4,
	AmgenFirstStepMedicalPayments: 5,
	AmgenFirstStepPharmaceuticalPayments: 6,
	FlatironPaymentsAndCharges: 7,
	MorphoSysPaymentsAndCharges: 8,
	AdvancedMdPaymentsAndCharges: 9,
	Genentech: 10,
	UnlimitedSystems: 11,
	Coherus: 12,
	Sanofi: 13,
	Amgen: 14,
	Flatiron: 15,
	MorphoSys: 16,
	AdvancedMD: 17,
	Manual: 9999,
};

export const ClaimTypeEnum = {
	Medical: 1,
	Pharmacy: 2,
}

export const SpecialFacilityOptionsEnum = {
	HospitalExternal: '99996',
	PharmacyBenefitSpecialtyRx: '99997',
	PharmacyBenefitIOD: '99998',
	FreeDrug: '99999',
}

export const SpecialProviderOptionsEnum = {
	ExternalProvider: '99999',
}

export const ActivityLogSearchTypes = {
	ApplicationWizard: 1,
	Watchlist: 2,
	Opportunities: 3,
	Reenrollment: 4
};

export const AssistanceFormEnum = {
	BeiGene: 19,
	Pfizer: 20,
	Genentech: 21,
	GoodDays: 22,
	Coherus: 23,
	Sanofi: 24,
	CoherusNonCopay: 25,
	Amgen: 26,
	HealthWell: 27,
	Injectafer: 31,
	Morphosys: 10000,
	GenentechHub: 18000,
	LashBms: 24000,
	LashEagle: 27000,
	PAN: 28000,
	Abbvie: 32000,
	LLS: 35000,
	CancerCare: 36000,
	PAF: 34000,
	Janssen: 39000
}

export const AssistanceServiceEnum = {
	EagleBA: 10842,
	EaglePA: 11699,
	EagleCopay: 11701,
	EaglePAP: 10844
}

export const UIStates = {
	Success: 'success',
	Error: 'error',
	Info: 'info'
}

export const BestTimeToCallOptions = [
	{ key: 1, value: '1', text: 'Morning' },
	{ key: 2, value: '2', text: 'Afternoon' },
	{ key: 3, value: '3', text: 'Evening' },
	{ key: 4, value: '4', text: 'Anytime' }
]
